import { Box, Spinner, SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';
import { Application } from 'src/components/context/AppContextModels';
import styles from './styles/EmbedApp.module.scss';

interface EmbedAppLoadingStateProps {
  application: Application;
}

export const EmbedAppLoadingState: React.FC<EmbedAppLoadingStateProps> = ({ application }) => {
  const applicationName = application?.applicationName || '';

  return (
    <div className={styles.centeredStateContainer}>
      <div className={styles.centeredStateContentWrapper}>
        <Box textAlign="center">
          <SpaceBetween direction="vertical" size="m">
            <Spinner size="large" />
            <Box variant="h3" color="text-status-info">
              Loading {applicationName}...
            </Box>
          </SpaceBetween>
        </Box>
      </div>
    </div>
  );
};
